"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LwtStoreProvider = exports.LwtStoreContext = void 0;
const react_1 = __importStar(require("react"));
const config_1 = __importDefault(require("../@internal/config"));
const { defaultA11ySettings } = config_1.default;
// TODO: tours, etc
const INITIAL_STATE = {
    hasSetStore: false,
    user: null,
    settings: { isLiteRoute: false, accessibility: defaultA11ySettings },
    featureToggles: []
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
exports.LwtStoreContext = react_1.default.createContext({});
const storeReducer = (state, action) => {
    var _a, _b, _c;
    switch (action.type) {
        case 'SET_SETTINGS': {
            return Object.assign(Object.assign({}, state), { hasSetStore: true, settings: Object.assign(Object.assign({}, action.payload), { accessibility: Object.assign(Object.assign({}, ((_a = action.payload.accessibility) !== null && _a !== void 0 ? _a : defaultA11ySettings)), { videoNarrationSettings: Object.assign({}, ((_c = (_b = action.payload.accessibility) === null || _b === void 0 ? void 0 : _b.videoNarrationSettings) !== null && _c !== void 0 ? _c : defaultA11ySettings.videoNarrationSettings)) }) }) });
        }
        case 'SET_FEATURE_TOGGLES': {
            return Object.assign(Object.assign({}, state), { hasSetStore: true, featureToggles: action.payload });
        }
        case 'SET_USER': {
            return Object.assign(Object.assign({}, state), { hasSetStore: true, user: action.payload });
        }
        case 'SET_LWT_STORE': {
            return Object.assign(Object.assign(Object.assign({}, state), { hasSetStore: true }), action.payload);
        }
        default:
            return state;
    }
};
const noop = (_) => __awaiter(void 0, void 0, void 0, function* () { return undefined; });
const LwtStoreProvider = (_a) => {
    var { saveSettings = noop } = _a, props = __rest(_a, ["saveSettings"]);
    const [state, dispatch] = (0, react_1.useReducer)(storeReducer, INITIAL_STATE);
    const setSettings = (value = {}) => {
        dispatch({ type: 'SET_SETTINGS', payload: value });
    };
    const setFeatureToggles = (value = []) => {
        dispatch({ type: 'SET_FEATURE_TOGGLES', payload: value });
    };
    const setUser = (value) => {
        dispatch({ type: 'SET_USER', payload: value });
    };
    const setStore = ({ settings, featureToggles = [], user }) => {
        dispatch({ type: 'SET_LWT_STORE', payload: { settings, featureToggles, user } });
    };
    const saveSettingsApi = (key, data) => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        const nextSettings = Object.assign(Object.assign({}, state.settings), { [key]: data });
        setSettings(nextSettings);
        // if 'saveSettings' method is undefined | isLiteRoute -> return 'nextSettings' from memory
        const response = ((_b = state.settings) === null || _b === void 0 ? void 0 : _b.isLiteRoute)
            ? nextSettings
            : yield (saveSettings === null || saveSettings === void 0 ? void 0 : saveSettings(nextSettings));
        return response !== null && response !== void 0 ? response : { data: nextSettings };
    });
    return (react_1.default.createElement(exports.LwtStoreContext.Provider, { value: [state, { setSettings, setFeatureToggles, setUser, setStore, saveSettingsApi }] }, props.children));
};
exports.LwtStoreProvider = LwtStoreProvider;
